module.exports = __webpack_public_path__ + "static/media/external-link-s-svgrepo-com.e111be65.svg";